import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  treeService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'authService',
    'additionalFieldService',
    'EQuickAccessItems',
    'EAdminFeatures',
    'EFeatures',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      authService,
      AdditionalField,
      EQuickAccessItems,
      EAdminFeatures,
      EFeatures,
      ETreeItemTypes
    ) {
      'use strict';

      var folderWithParentDeferred = null;
      var treeServiceFactory = {};
      var canSendTreeCache = null;

      var loadingItem = {
        Name: $filter('translate')('CHILDREN LOADING'),
        TreeItemType: ETreeItemTypes.LOADING,
        HasPermission: true,
      };

      var quickAcessItems = [
        {
          Id: EQuickAccessItems.QUICKACCESS,
          Name: $filter('translate')('QUICKACCESS'),
          TreeItemType: ETreeItemTypes.QUICK_ACCESS,
          Features: [],
          IsOpen: true,
          HasChildren: true,
          HasPermission: true,
          CanShow: function () {
            return true;
          },
          Order: 0,
          Children: [
            {
              Id: EQuickAccessItems.MYDEADLINES,
              Name: $filter('translate')('MY DEADLINES'),
              TreeItemType: ETreeItemTypes.MY_DOCS_EXPIRED,
              Order: 1,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.CHECKOUTS,
              Name: $filter('translate')('CHECKOUTS'),
              TreeItemType: ETreeItemTypes.CHECKOUTS,
              Order: 2,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.SHAREDDOCUMENTS,
              Name: $filter('translate')('SHARED DOCS'),
              TreeItemType: ETreeItemTypes.SHARED_DOCUMENTS,
              Order: 3,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.FAVORITES,
              Name: $filter('translate')('FAVORITES'),
              TreeItemType: ETreeItemTypes.FAVORITES,
              Order: 4,
              Features: [],
              IsOpen: true,
              HasPermission: true,
              CanShow: function () {
                return true;
              },
            },
            {
              Id: EQuickAccessItems.DIGITALIZATIONS,
              Name: $filter('translate')('PROCESSING'),
              TreeItemType: ETreeItemTypes.PENDING_SCAN,
              Order: 5,
              Features: [],
              IsOpen: true,
              IsNew: true,
              IsAI: true,
              HasPermission: true,
              CanShow: function () {
                const viewerServer = (webApiSettings.viewerServer || '').toUpperCase();

                return viewerServer === 'TESTE' || viewerServer === 'NOSSO';
              },
            },
          ],
        },
      ];

      function handleError(err, status) {
        if (status === 404) {
          var error = {
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function getByIdFolder(idFolder) {
        var deferred = $q.defer();
        $http
          .get(`${webApiSettings.apiServiceBaseUri}treeview/${idFolder}`)
          .then((result) => {
            var treeItem = result.data;

            deferred.resolve(treeItem);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function getExpiredNotification() {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
            'treeview/getNotificationForMyDeadLines'
          )
          .then((result) => {
            var data = result.data;
            deferred.resolve(data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);

            deferred.reject(error);
          });
        return deferred.promise;
      }

      function getRepositories(removeQuickAccess) {
        var deferred = $q.defer();

        $http
          .get(webApiSettings.apiServiceBaseUri + 'treeview/repositories', {
            ignoreLoadingBar: true,
          })
          .then(
            function (result) {
              var data = result.data;

              data.forEach(function (c) {
                c.Children = null;
                c.HasPermission =
                  c.HasPermission === null ? false : c.HasPermission;
                c.Order = 1;
                c.CanShow = function () {
                  return true;
                };
                c.HasChildrens = function () {
                  var notRemoved =
                    c.Children &&
                    c.Children.filter(function (item) {
                      return (
                        !item.removed &&
                        !(item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE || item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
                      );
                    });
                  if (
                    c.HasChildren &&
                    (c.Children === null || notRemoved.length > 0)
                  ) {
                    return true;
                  }
                };
              });

              var repositories = [{}];
              if (
                authService.authentication.email === 'autologin' ||
                removeQuickAccess
              ) {
                repositories = $filter('orderBy')(data, '+Name');
              } else {
                repositories = quickAcessItems.concat(
                  $filter('orderBy')(data, '+Name')
                );
                var trashCan = {
                  Id: EQuickAccessItems.TRASHCAN,
                  Name: 'TRASHCAN',
                  TreeItemType: 9,
                  Features: [],
                  IsOpen: true,
                  HasPermission: true,
                  ContextMenu: 'trashMenu',
                  CanShow: function () {
                    return authService.verifyHasAdminFeature([
                      EAdminFeatures.ManageTrashCan,
                    ]);
                  },
                  Order: 2,
                };
                repositories.push(trashCan);
              }

              deferred.resolve(repositories);
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function getChildren(folder) {
        var deferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'treeview/children',
            folder,
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;
              data.forEach(function (c) {
                c.Children = null;
                c.CanShow = function () {
                  return true;
                };
                c.IdParent = folder.Id;
                c.TreeItemType = c.TreeItemType === null ? 1 : c.TreeItemType;
                c.HasPermission =
                  c.HasPermission === null ? false : c.HasPermission;
                c.CanSendFiles =
                  authService.isAdmin() === true ||
                  (c.Features !== undefined &&
                    c.Features !== null &&
                    c.Features.includes(EFeatures.SEND_DOCUMENT));
                c.HasChildrens = function () {
                  var notRemoved =
                    c.Children &&
                    c.Children.filter(function (item) {
                      return (
                        !item.removed &&
                        !(item.TreeItemType === ETreeItemTypes.DOCUMENT_TYPE || item.TreeItemType === ETreeItemTypes.ADDITIONAL_FIELD)
                      );
                    });
                  return (
                    c.HasChildren &&
                    (c.Children === null ||
                      notRemoved === undefined ||
                      notRemoved === null ||
                      notRemoved.length > 0)
                  );
                };
              });

              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function recursiveCreateSendFilesTree(items, parent) {
        if (!items._byParent) {
          var byParent = {};
          for (var i = 0, len = items.length; i < len; i++) {
            var it = items[i];
            var key =
              it.IdParent === undefined || it.IdParent === null
                ? 'root'
                : it.IdParent;
            if (!byParent[key]) {
              byParent[key] = [];
            }
            byParent[key].push(it);
          }
          items._byParent = byParent;
        }

        var byParent = items._byParent;

        if (parent === undefined || parent === null) {
          return;
        }

        parent.name = parent.Name;
        parent.toString = function () {
          return this.name;
        };

        var children = byParent[parent.Id] || [];
        parent.children = children;
        parent.HasChildren = children.length > 0;

        for (var j = 0, clen = children.length; j < clen; j++) {
          var item = children[j];
          item.name = item.Name;
          item.TreeItemType =
            item.TreeItemType === null ? ETreeItemTypes.FOLDER : item.TreeItemType;
          // mesma lógica do original
          item.HasPermission =
            item.HasPermission === null ? false : item.TreeItemType;
          item.toString = function () {
            return this.name;
          };
        }

        for (var k = 0; k < children.length; k++) {
          if (children[k].TreeItemType !== ETreeItemTypes.LOADING) {
            recursiveCreateSendFilesTree(items, children[k]);
          }
        }
      }

      function recursiveCreateTree(items, parent) {
        //Verifica se existem algum item que seja filho do 'parent'
        if (
          parent !== null &&
          parent !== undefined &&
          items.some(function (c) {
            return c.IdParent === parent.Id;
          })
        ) {
          for (var i = 0, len = items.length; i < len; i++) {
            var c = items[i];

            c.TreeItemType = c.TreeItemType === null ? ETreeItemTypes.FOLDER : c.TreeItemType;
            c.HasPermission =
              c.HasPermission === null ? false : c.HasPermission;
            c.CanSendFiles =
              authService.isAdmin() === true ||
              (c.Features !== undefined &&
                c.Features !== null &&
                c.Features.includes(EFeatures.SEND_DOCUMENT));
          }

          // Insere os filhos
          parent.Children = items.filter(function (c) {
            return c.IdParent === parent.Id;
          });

          // Insere o carregando
          parent.Children.push(loadingItem);
        } else {
          return;
        }

        //Chama o create tree para cada um dos filhos
        parent.Children.filter(function (c) {
          return c.TreeItemType !== ETreeItemTypes.LOADING;
        }).forEach(function (c) {
          recursiveCreateTree(items, c);
        });
      }

      function getFolderWithAncestors(idFolder) {
        var deferred = $q.defer();
        folderWithParentDeferred = deferred;

        if (idFolder) {
          $http
            .get(
              webApiSettings.apiServiceBaseUri +
              'treeview/ancestors/' +
              idFolder
            )
            .then(function (result) {
              var data = result.data;
              var first = data.filter(
                (c) => c.IdParent === undefined || c.IdParent === null
              )[0];

              data.forEach((item) => {
                item.CanShow = () => true;
              });

              recursiveCreateTree(data, first);

              deferred.resolve(first);

              if (folderWithParentDeferred === deferred) {
                folderWithParentDeferred = null;
              }
            })
            .catch((err) => {
              var error = handleError(err.data, err.status);

              deferred.reject(error);

              if (folderWithParentDeferred === deferred) {
                folderWithParentDeferred = null;
              }
            });
        } else {
          deferred.resolve(null);
        }

        return deferred.promise;
      }

      function getFolderDocumentTypes(idFolder) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
            'documentType/folderdocstypes/' +
            idFolder
          )
          .then((result) => {
            var data = result.data;
            deferred.resolve(data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);

            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getDocumentTypeAdditionalFields(idDocumentType) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
            'additionalField/fieldsByDocType/' +
            idDocumentType
          )
          .then(
            (result) => {
              var data = result.data;
              var fields = [];
              data = resolveReferences(data);
              if (Array.isArray(data)) {
                data.forEach(function (item) {
                  fields.push(new AdditionalField(item));
                });
              }

              deferred.resolve(fields);
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function getCanSendFolders() {
        var deferred = $q.defer();

        var now = new Date();

        var hourMilisecs = 1000 * 60 * 60;

        if (
          treeServiceFactory.canSendTreeCache !== null &&
          treeServiceFactory.canSendTreeCache.date.getTime() >
          now.getTime() - hourMilisecs
        ) {
          deferred.resolve(treeServiceFactory.canSendTreeCache.tree);
        }

        $http
          .get(
            webApiSettings.apiServiceBaseUri + 'treeview/canSendDocumentTree',
            {
              ignoreLoadingBar: true,
            }
          )
          .then(
            function (result) {
              var data = result.data;

              var repositories = data.filter(function (f) {
                return f.IdParent === undefined || f.IdParent === null;
              });

              repositories.forEach(function (r) {
                r.TreeItemType = ETreeItemTypes.REPOSITORY;
                if (r.HasPermission === undefined || r.HasPermission === null) {
                  r.HasPermission = false;
                }
              });

              repositories.forEach(function (r) {
                recursiveCreateSendFilesTree(data, r);
              });

              treeServiceFactory.canSendTreeCache = {
                date: now,
                tree: repositories,
              };

              deferred.resolve(repositories);
            },
            function (err) {
              var error = handleError(err.data, err.status);

              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          treeServiceFactory.canSendTreeCache = canSendTreeCache;
          treeServiceFactory.loadingItem = loadingItem;
          treeServiceFactory.quickAcessItems = quickAcessItems;

          treeServiceFactory.getRepositories = logWrapper(
            getRepositories,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getChildren = logWrapper(
            getChildren,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getFolderWithAncestors = logWrapper(
            getFolderWithAncestors,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getCanSendFolders = logWrapper(
            getCanSendFolders,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getFolderDocumentTypes = logWrapper(
            getFolderDocumentTypes,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getDocumentTypeAdditionalFields = logWrapper(
            getDocumentTypeAdditionalFields,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getByIdFolder = logWrapper(
            getByIdFolder,
            runtimeConstant.isDebugServicesInternals
          );
          treeServiceFactory.getExpiredNotification = logWrapper(
            getExpiredNotification,
            runtimeConstant.isDebugServicesInternals
          );

          return treeServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
